import { render, staticRenderFns } from "./RegionalAccounts.vue?vue&type=template&id=1cf28cca&"
import script from "./RegionalAccounts.vue?vue&type=script&lang=js&"
export * from "./RegionalAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports